module.exports = __webpack_public_path__ + "static/media/kran2.bc246b0a.fbx";